export const maxReferenceFileSize = 2 * 1024 * 1024; // 2MB
export const defaultMaxFileSize = 2 * 1024 * 1024; // 2MB
export const importProjectZipMaxFileSize = 50 * 1024 * 1024; // 50MB
